import axios from "axios";
import { apiURL } from "../config/config";

// window events ระหว่าง socket listener ใน App.js กับกระดิ่งใน Header
export const NOTIFICATION_RECEIVED_EVENT = "neon:notification-received";
export const NOTIFICATION_SOCKET_REGISTER_EVENT = "neon:notification-socket-register";
// App.js อยู่นอก Router จึงส่งการคลิก toast มาให้กระดิ่งเป็นคน navigate
export const NOTIFICATION_TOAST_CLICK_EVENT = "neon:notification-toast-click";

export const NOTIFICATION_PAGE_SIZE = 20;

const getAuthConfig = (config = {}) => {
  const token = localStorage.getItem("token");

  return {
    ...config,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(config.headers || {}),
    },
  };
};

const buildModuleParams = (module) => (module ? { module } : {});

export const listNotifications = async ({
  page = 1,
  limit = NOTIFICATION_PAGE_SIZE,
  module = "",
  unreadOnly = false,
} = {}) => {
  const response = await axios.get(`${apiURL}notifications`, {
    ...getAuthConfig(),
    params: {
      page,
      limit,
      ...buildModuleParams(module),
      ...(unreadOnly ? { unreadOnly: true } : {}),
    },
  });

  const payload = response.data || {};
  return {
    data: Array.isArray(payload.data) ? payload.data : [],
    unreadCount: Number(payload.unreadCount) || 0,
    pagination: payload.pagination || { page, limit, total: 0, totalPages: 0 },
  };
};

export const getUnreadNotificationCount = async ({ module = "" } = {}) => {
  const response = await axios.get(`${apiURL}notifications/unread-count`, {
    ...getAuthConfig(),
    params: buildModuleParams(module),
  });

  return Number(response.data?.data?.unreadCount) || 0;
};

export const markNotificationAsRead = async (id) => {
  const response = await axios.patch(
    `${apiURL}notifications/${id}/read`,
    null,
    getAuthConfig()
  );
  return response.data?.data;
};

export const markAllNotificationsAsRead = async ({ module = "" } = {}) => {
  const response = await axios.patch(`${apiURL}notifications/read-all`, null, {
    ...getAuthConfig(),
    params: buildModuleParams(module),
  });
  return Number(response.data?.data?.updatedCount) || 0;
};
